import { FALSE, TRUE } from "./primitives";

import { CookieCategory } from "types/consent";

export const NECESSARY = "necessary";
export const PERFORMANCE = "performance";
export const FUNCTIONAL = "functional";
export const ADVERTISING = "advertising";
export const UNCLASSIFIED = "unclassified";
export const IAB_PURPOSES = "iab_purposes";

export const categories: CookieCategory[] = [
  NECESSARY,
  PERFORMANCE,
  FUNCTIONAL,
  ADVERTISING
];

// empty consent, for example when user clicks "deny" - which means he accept only necessay
export const EMPTY_CONSENT = Object.freeze({});

export const FULL_CATEGORY_CONSENT = Object.freeze({
  [NECESSARY]: TRUE,
  [PERFORMANCE]: TRUE,
  [FUNCTIONAL]: TRUE,
  [ADVERTISING]: TRUE,
});

export const EMPTY_CATEGORY_CONSENT = Object.freeze({
  [NECESSARY]: TRUE,
  [PERFORMANCE]: FALSE,
  [FUNCTIONAL]: FALSE,
  [ADVERTISING]: FALSE,
});

// no consent - this is before user saves their preference
export const NO_CONSENT = null;
